import { render, staticRenderFns } from "./customerContact.vue?vue&type=template&id=55fcb254&"
import script from "./customerContact.vue?vue&type=script&lang=js&"
export * from "./customerContact.vue?vue&type=script&lang=js&"
import style0 from "./customerContact.vue?vue&type=style&index=0&id=55fcb254&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports